import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, memo } from 'react';
import Input from '../elements/Input';
import ReactTableFlexLayout from '../elements/ReactTable/ReactTableFlexLayout';
import useSpectrum from '../hooks/useSpectrum';
const styles = {
    container: {
        height: '100%',
        flexDirection: 'column',
        display: 'flex',
        width: '100%',
    },
    tableContainer: {
        overflow: 'auto',
        display: 'block',
    },
    tableHeader: {
        padding: ' 5px 10px',
        backgroundColor: ' #f8f8f8',
        borderBottom: '1px solid gray',
        fontSize: '1em',
        cursor: 'pointer',
    },
};
function Arrow(props) {
    const { isOpen = true } = props;
    return (_jsx("div", { style: {
            fontSize: '1.3em',
            transform: `rotate(${isOpen ? 90 : 0}deg)`,
            transformOrigin: '50% 50%',
            display: 'inline-block',
            lineHeight: 1,
            padding: isOpen ? '5px 0 0 0' : '0 5px 0 0',
            verticalAlign: 'middle',
        }, children: "\u2023" }));
}
function InformationTable(props) {
    const { data, columns, title, onClick, isOpen = true } = props;
    return (_jsxs(_Fragment, { children: [_jsxs("div", { style: styles.tableHeader, onClick: onClick, children: [_jsx(Arrow, { isOpen: isOpen }), _jsx("span", { style: { verticalAlign: 'middle', display: 'inline-block' }, children: title })] }), isOpen && (_jsx(ReactTableFlexLayout, { data: data, columns: columns, style: { height: 'auto' } }))] }));
}
function filter(searchKey, data) {
    const result = [];
    for (const key in data) {
        if (!searchKey || key.toLowerCase().includes(searchKey)) {
            result.push({ key, value: data[key] });
        }
    }
    return result;
}
const columns = [
    {
        Header: 'Parameter',
        sortType: 'basic',
        minWidth: 100,
        width: 20,
        maxWidth: 20,
        accessor: 'key',
        Cell: ({ row }) => (_jsx("p", { style: { padding: '5px', backgroundColor: 'white' }, children: row.original.key })),
    },
    {
        Header: 'Value',
        sortType: 'basic',
        resizable: true,
        accessor: 'value',
        Cell: ({ row }) => (_jsx("p", { style: {
                backgroundColor: '#efefef',
                height: '100%',
                padding: '5px',
                fontFamily: 'monospace',
                whiteSpace: 'pre',
                overflow: 'hidden',
            }, children: `${row.original.value}` })),
    },
];
function InformationPanelInner({ info, meta, metaInfo, }) {
    const [searchKey, setSearchKey] = useState();
    const [panelsStatus, openPanel] = useState({
        info: true,
        meta: true,
        metaInfo: true,
    });
    function handleSearch(e) {
        const searchKey = e.target.value.toLowerCase();
        setSearchKey(searchKey);
    }
    const matchesInfo = filter(searchKey, info);
    const matchesMeta = filter(searchKey, meta);
    const matchesMetaInfo = filter(searchKey, metaInfo);
    function handleOpen(key) {
        openPanel((prevPanelsStatus) => ({
            ...prevPanelsStatus,
            [key]: !prevPanelsStatus[key],
        }));
    }
    return (_jsxs("div", { style: styles.container, children: [_jsx("div", { children: _jsx(Input, { placeholder: "Search for parameter...", onChange: handleSearch, debounceTime: 250, style: {
                        inputWrapper: { width: '100%' },
                        input: { textAlign: 'left', padding: '5px' },
                    } }) }), _jsxs("div", { style: styles.tableContainer, children: [_jsx(InformationTable, { data: matchesInfo, columns: columns, title: "Spectrum information", onClick: () => handleOpen('info'), isOpen: panelsStatus.info }), _jsx(InformationTable, { data: matchesMeta, columns: columns, title: "Other parameters", onClick: () => handleOpen('meta'), isOpen: panelsStatus.meta }), _jsx(InformationTable, { data: matchesMetaInfo, columns: columns, title: "Meta Info parameters", onClick: () => handleOpen('metaInfo'), isOpen: panelsStatus.metaInfo })] })] }));
}
const MemoizedInformationPanel = memo(InformationPanelInner);
const emptyData = { info: {}, meta: {} };
export default function InformationPanel() {
    const { info, meta, metaInfo } = useSpectrum(emptyData);
    return _jsx(MemoizedInformationPanel, { ...{ info, meta, metaInfo } });
}
